import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const phrases = [
  "Beyond limits.",
  "Automating the future.",
  "Think AI. Think Venpa AI."
];

export default function Intro({ onComplete }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < phrases.length) {
      // The last phrase stays on screen a bit longer before fading out
      const duration = index === phrases.length - 1 ? 2200 : 1200;
      const timer = setTimeout(() => setIndex(i => i + 1), duration);
      return () => clearTimeout(timer);
    } else {
      setTimeout(() => onComplete(), 500); // Trigger the unmount
    }
  }, [index, onComplete]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0A0F2C]"
      initial={{ y: 0 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="overflow-hidden px-4 text-center">
        <AnimatePresence mode="wait">
          {index < phrases.length && (
            <motion.p
              key={index}
              className={`display text-4xl md:text-5xl lg:text-7xl tracking-tight ${
                index === phrases.length - 1
                  ? "text-brand-gradient animate-gradient-x"
                  : "text-white"
              }`}
              initial={{ y: "100%" }}
              animate={{ y: "0%" }}
              exit={{ y: "-100%" }}
              transition={{ duration: 0.5, ease: [0.33, 1, 0.68, 1] }}
            >
              {phrases[index]}
            </motion.p>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
